import * as React from 'react';
import { resetUrl } from '../../common/reset-image';
import ReactImageMagnify from 'react-image-magnify';

interface propTypes {
    src: string;
}

export default function MainImage ( props: propTypes ) {
    const { src } = props;

    return (
        <ReactImageMagnify
            {...{
                imageClassName: 'main-img',
                smallImage: {
                    alt: 'Wristwatch by Ted Baker London',
                    isFluidWidth: true,
                    onLoad: () => {
                        ( function () {
                            var bb = ( window as any ).__BB;
                            if ( !bb ) bb = ( window as any ).__BB = {};
                            bb.mode = -1;
                            bb.exposed = new Date();
                        } )();
                    },
                    src: resetUrl( src,'720', 'q50' )
                },
                largeImage: {
                    src: `${resetUrl( src,'960' )}?quality=close`,
                    width: 960,
                    height: 960
                }
            }} />
    );
}
